module.exports = __webpack_public_path__ + "static/media/bokmal-ordforstaelse.cc17a14e.mp3";